import React, { Component } from "react";
import { BoxInfo, ErrorNotification, MnemoLoading, ModalHandler, MSection } from "components/misc";
import { Button, Container, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter } from "design-react-kit";
import { MInput, MSelect } from "components/forms";
import { enrollmentEvaluationServiceIndire, networkErrorHelper } from "libs";
import { esse3Service } from "libs/api/esse3Service";
import dayjs from "dayjs";
import { COMPANY } from "const";

const CLOSE_ENROLLMENT_PASSWORD = "swelop";

export class AnalysisEvaluationReportIndire extends Component {

  state = {
    loading: false,
    currentAA: "",
    currentEdition: "",
    currentCompany: "",
    bandiList: [],
    currentBando: null,
    userEvaluations: [],

    closeEnrollmentPassword: "",
    isCloseEnrollmentOpen: false,
  };

  PAYLOAD_YEAR = {
    options: [
      { label: "SELEZIONA UN ANNO ACCADEMICO", value: 0 },
      { label: "2025/2026", value: 2025 },
    ],
  };

  PAYLOAD_EDITION = {
    options: [
      { label: "Seleziona edizione", value: "" },
      { label: "UNO", value: "1" },
    ]
  };

  PAYLOAD_COMPANY = {
    options: [
      { label: "Seleziona Università", value: "" },
      { label: "Unitelma La Sapienza", value: "unitelma" },
    ]
  };

  onChangeAA = (_, value) => {
    this.setState({
      currentAA: value,
      currentEdition: "",
      currentCompany: "",
      bandiList: [],
      userEvaluations: [],
      currentBando: null,
    });
  };

  onChangeEdition = (_, value) => {
    this.setState({
      currentEdition: value,
      currentCompany: "",
      bandiList: [],
      userEvaluations: [],
      currentBando: null,
    });
  };

  onChangeCompany = (_, value) => {
    this.setState({
      currentCompany: value,
      bandiList: [],
      userEvaluations: [],
      currentBando: null,
    });
  };

  /** 
  TODO
  setRinuncia = (itemId) => {
    this.setState({ currentItemId: itemId });
    ModalHandler.show(
      null,
      "Rinuncia",
      "Lo studente verrà escluso dalla graduatoria e non potrà piu immatricolarsi. Il file PDF dovrà essere rigenerato. Confermi? ",
      null,
      this.confirmRinuncia,
    );
  };

  confirmRinuncia = () => {
    this.setState({ loading: true, loadingError: "" });
    const { currentItemId, currentBando } = this.state;
    enrollmentEvaluationServiceIndire
      .rejectEvaluation(currentItemId)
      .then(({ data }) => {
        this.loadStudents(currentBando?.id);
      })
      .catch((error) => {
        networkErrorHelper.notify(error);
        this.setState({ loading: false });
      });
  };

  setAmmetti = (itemId) => {
    this.setState({ currentItemId: itemId });
    ModalHandler.show(
      null,
      "Ammetti",
      "Lo studente verrà considerato vincitore potrà immatricolarsi. Il file PDF dovrà essere rigenerato. Confermi? ",
      null,
      this.confirmAmmetti,
    );
  };

  confirmAmmetti = () => {
    this.setState({ loading: true, loadingError: "" });
    const { currentItemId, bandoId } = this.state;
    enrollmentEvaluationServiceIndire
      .admitEvaluation(currentItemId)
      .then(({ data }) => {
        this.setState({ loading: false });
        this.loadStudents(bandoId);
      })
      .catch((error) => {
        console.log(error);
        networkErrorHelper.notify(error);
        this.setState({ loading: false });
      });
  };

  onAnalyze = () => {
    ModalHandler.show(
      null,
      "Calcolo punteggi",
      "Verrà avviata la procedura di calcolo dei punteggi per i bandi dell'edizione e università selezionati. Vuoi procedere? ",
      null,
      this.confirmAnalyze,
    );
  };

  onCreatePositions = () => {
    ModalHandler.show(
      null,
      "Calcolo graduatorie",
      "Verranno create le graduatorie per i bandi dell'edizione e università selezionati. Vuoi procedere? ",
      null,
      this.confirmCreatePositions,
    );
  };

  onExportPositions = () => {
    ModalHandler.show(
      null,
      "Esporta graduatorie",
      "Verranno esportate le graduatorie per i bandi dell'edizione e università selezionati. Vuoi procedere? ",
      null,
      this.confirmExportPositions,
    );
  };

  onCloseEnrollmentBando = () => {
    this.setState({ isCloseEnrollmentOpen: true, closeEnrollmentPassword: "" });
  };

  toggleModal = () => {
    this.setState({ isCloseEnrollmentOpen: !this.state.isCloseEnrollmentOpen });
  }; 

  confirmExportPositions = () => {
    const { currentCompany, currentEdition, currentAA } = this.state;
    this.setState({ loading: true });

    enrollmentEvaluationServiceIndire
      .exportPositions(currentCompany, currentEdition, currentAA)
      .then(({ data }) => {
        const originalName =
          currentCompany + "_graduatorie_edizione_" + currentEdition + "_" + currentAA + "_" + dayjs().format("DD_MM_YYYY_H_m_s") + ".xlsx";

        const downloadUrl = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", originalName);
        document.body.appendChild(link);
        link.click();
        link.remove();

        this.setState({ loading: false });
      })
      .catch((error) => {
        console.log(error);
        networkErrorHelper.notify(error);
        this.setState({ loading: false });
      });
  };

  confirmAnalyze = () => {
    const { currentCompany, currentEdition, currentAA } = this.state;

    this.setState({ loading: true });
    enrollmentEvaluationServiceIndire
      .analyze(currentCompany, currentEdition, currentAA)
      .then(({ data }) => {
        this.setState({ loading: false });
      })
      .catch((error) => {
        console.log(error);
        networkErrorHelper.notify(error);
        this.setState({ loading: false });
      });
  };

  confirmCreatePositions = () => {
    const { currentCompany, currentEdition, currentAA } = this.state;

    this.setState({ loading: true });

    enrollmentEvaluationServiceIndire
      .createPositions(currentCompany, currentEdition, currentAA)
      .then(({ data }) => {
        this.setState({ loading: false });
      })
      .catch((error) => {
        console.log(error);
        networkErrorHelper.notify(error);
        this.setState({ loading: false });
      });
  };

  confirmCloseEnrollmentBando = () => {
    const { currentCompany, currentEdition, currentAA, closeEnrollmentPassword } = this.state;

    if (!closeEnrollmentPassword || closeEnrollmentPassword.trim() === "") {
      ErrorNotification.render("È necessario inserire la password per procedere.");
      return;
    }

    if (closeEnrollmentPassword !== CLOSE_ENROLLMENT_PASSWORD) {
      ErrorNotification.render("Password errata.");
      return;
    }

    this.setState({ loading: true });

    enrollmentEvaluationServiceIndire
      .closeEnrollmentBando(currentCompany, currentEdition, currentAA)
      .then(({ data }) => {
        this.setState({ loading: false, closeEnrollmentPassword: "" });
      })
      .catch((error) => {
        console.log(error);
        networkErrorHelper.notify(error);
        this.setState({ loading: false });
      });
  };
*/

  loadBandi = () => {
    const { currentCompany, currentEdition, currentAA } = this.state;
    if (!currentCompany || !currentEdition || !currentAA) {
      ErrorNotification.render("Devi selezionare tutti i dati prima di caricare i bandi");
      return;
    }

    this.setState({ loading: true });

    enrollmentEvaluationServiceIndire
      .bandoEvaluationInfoList(currentEdition, currentAA, currentCompany)
      .then(({ data }) => {
        const bandiList = data.payload.bandiEvaluationInfo;

        this.setState({
          bandiList,
          loading: false,
          userEvaluations: [],
          currentBando: null,
        });
      })
      .catch((error) => {
        console.log(error);
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
        }

        this.setState({
          bandiList: [],
          loading: false,
          userEvaluations: [],
          currentBando: null,
        });
      });
  };

  loadStudents = (bandoId) => {
    this.setState({ loading: true, loadingError: "" });

    if (bandoId) {
      enrollmentEvaluationServiceIndire
        .positionsList(bandoId)
        .then(({ data }) => {
          const { userEvaluations } = data.payload;
          this.setState({ userEvaluations, loading: false });
        })
        .catch((error) => {
          console.log(error);
          if (!networkErrorHelper.is404(error)) {
            networkErrorHelper.notify(error);
          }
        });
    } else {
      this.setState({ loading: false, loadingError: "" });
      ErrorNotification.render("Devi inserire tutti i dati prima di proseguire");
    }
  };

  rebuildPdf = (e) => {
    e.preventDefault();
    const { bando } = this.state;
    if (bando) {
      this.setState({ loading: true, loadingError: "" });
      enrollmentEvaluationServiceIndire
        .rebuildPDF(bando.id)
        .then(({ data }) => {
          this.setState({ loading: false });
        })
        .catch((error) => {
          networkErrorHelper.notify(error);
          this.setState({ loading: false });
        });
    } else {
      ErrorNotification.render("Nessun bando attivo da ricreare ");
    }
  };

  onExportEnrolled = () => {
    ModalHandler.show(
      null,
      "Esporta graduatorie",
      "Verrà esportata la lista degli iscritti per l'università selezionata. Vuoi procedere? ",
      null,
      this.confirmExportEnrolled,
    );
  };

  confirmExportEnrolled = () => {
    const { currentAA, currentCompany } = this.state;
    this.setState({ loading: true });

    enrollmentEvaluationServiceIndire
      .exportEnrolled(currentAA, currentCompany)
      .then(({ data }) => {
        const originalName = currentCompany + "_iscritti_" + currentAA + "_" + dayjs().format("DD_MM_YYYY_H_m_s") + ".xlsx";

        const downloadUrl = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", originalName);
        document.body.appendChild(link);
        link.click();
        link.remove();

        this.setState({ loading: false });
      })
      .catch((error) => {
        console.log(error);
        networkErrorHelper.notify(error);
        this.setState({ loading: false });
      });
  }; // onExportEnrolled

  onExportEsse3 = () => {
    this.setState({ loading: true });
    const { currentAA, currentCompany } = this.state;

    esse3Service
      .exportRankingsByCompany(currentAA, currentCompany)
      .then((response) => {
        // response.data è un Blob
        const blob = new Blob([response.data], {
          type: response.headers["content-type"] || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        let fileName = `graduatorie_esse3_${currentCompany}_aa_${currentAA}_${dayjs().format("DD_MM_YYYY_H_m_s")}.xlsx`;

        // Creo URL temporaneo
        const downloadUrl = window.URL.createObjectURL(blob);

        // Creo <a> nascosto per far partire il download
        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();

        // Pulizia URL
        window.URL.revokeObjectURL(downloadUrl);
      })
      .catch((error) => {
        console.log(error);
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
        }
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }; // onExportEsse3

  //--- ---
  render() {
    const {
      loading,
      userEvaluations,
      currentBando,
      currentCompany,
      currentEdition,
      currentAA,
      bandiList,
    } = this.state;

    return (
      <>
        {loading && <MnemoLoading></MnemoLoading>}
        <Container className="m-4">
          <h1>Consultazione Graduatorie</h1>
          <MSection>
            <Row className="mt-4">
              <Col md={12}>
                <MSelect onChange={this.onChangeAA} id="aa" payload={this.PAYLOAD_YEAR} />
              </Col>
            </Row>

            {currentAA > 0 && (

              <Row>
                <Col md={12}>
                  <MSelect onChange={this.onChangeEdition} id="edition" payload={this.PAYLOAD_EDITION} />
                </Col>
              </Row>
            )}

            {currentEdition && (
              <Row>
                <Col md={2}>
                  <MSelect onChange={this.onChangeCompany} id="company" payload={this.PAYLOAD_COMPANY} />
                </Col>
              </Row>
            )}

            {currentCompany && (
              <Row className="mt-3">
                <Col md={3}>
                  <Button className="mx-1" color="primary bg-dark" onClick={this.loadBandi}>
                    Carica bandi
                  </Button>
                </Col>
              </Row>
            )}

            {bandiList && bandiList.length > 0 && (
              <>
                <Row className="mt-5">
                  <Col >
                    <MSelect value={currentBando.id} label="Classe di concorso" payload={this.payloadCurrentBandi} onChange={this.onChangeCurrentBando} />
                  </Col>
                </Row>
                <Row>
                  <Button className="mx-1" color="primary bg-dark" onClick={this.onAnalyze}>
                    Calcola punteggi
                  </Button>
                  <Button className="mx-1" color="primary bg-dark" onClick={this.onCreatePositions}>
                    Calcola graduatorie
                  </Button>
                  <Button className="mx-1" color="primary" outline onClick={this.onExportPositions}>
                    Esporta graduatorie
                  </Button>
                </Row>
                <Row className="mt-5">
                  <Button className="mx-1" color="danger" outline onClick={this.onCloseEnrollmentBando}>
                    Chiudi Immatricolazioni
                  </Button>

                  <Button className="mx-1" color="primary" outline onClick={this.onExportEnrolled}>
                    Esporta iscritti<br />TUTTE EDIZIONI
                  </Button>
                  {currentCompany === COMPANY.UNITELMA && (
                    <Button color="primary" outline onClick={this.onExportEsse3}>
                      Esporta (Esse3)<br />TUTTE EDIZIONI
                    </Button>
                  )}
                </Row>
                <Row className="mt-5">
                  <Col>
                    <Button href={currentBando.url} color="primary bg-dark" target="_blank" rel="noopener noreferrer">
                      Apri file graduatorie
                    </Button>
                    <Button
                      className="ml-2"
                      color="primary bg-dark"
                      onClick={(e) => {
                        this.rebuildPdf(e);
                      }}
                    >
                      <span className="d-button-label">Ricrea il file graduatorie</span>
                    </Button>
                  </Col>
                </Row>
              </>
            )}

            <hr />
          </MSection>

          <MSection>
            {!userEvaluations || userEvaluations.length === 0 ? (
              <BoxInfo>Non ci sono dati da mostrare in database.</BoxInfo>
            ) : (
              <>               
                <Row>
                  <table className="MTable table  table-striped table-hover">
                    <thead>
                      <tr>
                        <th>Posizione</th>
                        <th>
                          Identificativo
                          <br />
                          domanda
                        </th>
                        <th>Punteggio</th>
                        <th>Data di nascita</th>
                        <th>Tipo di ingresso</th>

                        <th>Nome completo</th>
                        <th>Contatti</th>
                        <th>
                          codice
                          <br />
                          Registrazione
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {userEvaluations.map((item, index) => (
                        <tr key={index}>
                          <td>
                            {item.position}
                            <br />
                            {item.status === "ok" ? (
                              <>
                                <span className="text-danger pointer" onClick={(e) => this.setRinuncia(item.idEvaluation)}>
                                  Rinuncia{" "}
                                </span>{" "}
                              </>
                            ) : (
                              <>
                                <span className="text-primary pointer" onClick={(e) => this.setAmmetti(item.idEvaluation)}>
                                  Ammetti
                                </span>{" "}
                              </>
                            )}{" "}
                          </td>
                          <td>{item.gompid}</td>
                          <td>{item.voteSum}</td>
                          <td>{item.dob}</td>
                          <td>{item.note ? <span className="text-danger pointer">{item.note}</span> : <span>{item.label}</span>}</td>
                          <td>{item.name}</td>
                          <td>{item.contacts}</td>
                          <td>{item.orderNumber}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Row>
              </>
            )}
          </MSection>
        </Container>

        {/* Modal chiusura immatricolazioni */}
        <Modal isOpen={this.state.isCloseEnrollmentOpen} toggle={this.toggleModal} centered size="lg">
          <ModalHeader toggle={this.toggleModal}>Chiusura Immatricolazione</ModalHeader>
          <ModalBody>
            <p>
              Verrà chiusa l'immatricolazione per i bandi dell'edizione e università selezionati. Vuoi procedere? <br />
              <strong>ATTENZIONE:</strong> chi non ha pagato verrà considerato rinunciatario e farà attivare lo scorrimento.
            </p>
            <Row className="mt-4">
              <Col md="6">
                <MInput
                  id="closeEnrollmentPassword"
                  name="closeEnrollmentPassword"
                  type="password"
                  label="Inserisci la password per confermare"
                  value={this.state.closeEnrollmentPassword}
                  onChange={(_, value) => this.setState({ closeEnrollmentPassword: value })}
                />
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" outline onClick={this.toggleModal}>
              Annulla
            </Button>
            <Button
              color="primary bg-dark"
              onClick={() => {
                this.toggleModal();
                this.confirmCloseEnrollmentBando();
              }}
            >
              Conferma
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}
